import {Component, Inject, OnInit} from '@angular/core';
import {MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA} from '@angular/material';

@Component({
    selector: 'app-sort-consent-bottom-sheet',
    templateUrl: './sort-consent-bottom-sheet.component.html',
    styleUrls: ['./sort-consent-bottom-sheet.component.scss']
})
export class SortConsentBottomSheetComponent implements OnInit {
    items: any[];

    constructor(private bottomSheetRef: MatBottomSheetRef<SortConsentBottomSheetComponent>,
                @Inject(MAT_BOTTOM_SHEET_DATA) public data) {
        this.items = data.items;
    }

    ngOnInit(): void {
    }

    dismiss(item: any) {
        this.bottomSheetRef.dismiss(item);
    }
}
